import React, { useEffect } from "react";
import { useStyles } from "./ButtonsStyles.css";
import { Button } from "@mui/material";
import { FormattedMessage } from "react-intl";
const DecisionButton = ({
    buttonId,
    title,
    value,
    athlete,
    defaultKey,
    onButtonClick,
    disabled,
}) => {
    const classes = useStyles();

    const customButtonId = `${title}.${athlete}`;

    useEffect(() => {
        function handleKeyUp(event) {
            event.preventDefault();
            if (event.key === defaultKey) {
                document.getElementById(customButtonId).click();
            }
        }

        document.addEventListener("keyup", handleKeyUp);

        return () => document.removeEventListener("keyup", handleKeyUp);
    }, []);

    return (
        <Button
            id={customButtonId}
            className={
                athlete === "red" ? classes.btnDecisionRed : classes.btnDecisionBlue
            }
            variant="contained"
            size="large"
            onClick={
                !isNaN(buttonId)
                    ? () => onButtonClick(value)
                    : () => onButtonClick(buttonId, value)
            }
            disabled={disabled}
        >
            <FormattedMessage id={title} defaultMessage={buttonId} />
        </Button>
    );
};

export default DecisionButton;
